import { recentDealsReducer } from '@makemydeal/dr-activities-recent-deals';
import { recentDealsMiddleware } from './middleware';

export const recentDealsConfiguration = {
    middleware: recentDealsMiddleware,
    reducer: recentDealsReducer
};
